// src/admin/components/DepartmentsList.tsx
import { useOrganizationDepartments } from '@/organization/useOrganizations';
import { Department } from '@/types/department';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

interface DepartmentsListProps {
  organizationId: string;
}

export function DepartmentsList({ organizationId }: DepartmentsListProps) {
  const { data: departments, isLoading } =
    useOrganizationDepartments(organizationId);

  if (!organizationId) {
    return (
      <Typography variant={'body1'} color={'text.secondary'}>
        Select an organization to view its departments
      </Typography>
    );
  }

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant={'h6'}>Departments</Typography>
        <Button variant={'contained'} color={'primary'} size={'small'}>
          Add Department
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell align={'right'}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {departments?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align={'center'}>
                  No departments found
                </TableCell>
              </TableRow>
            ) : (
              departments?.map((dept: Department) => (
                <TableRow key={dept.id}>
                  <TableCell>{dept.name}</TableCell>
                  <TableCell>{dept.description}</TableCell>
                  <TableCell>{dept.owner ? 'Assigned' : 'None'}</TableCell>
                  <TableCell align={'right'}>
                    <Button size={'small'} color={'primary'}>
                      Edit
                    </Button>
                    <Button size={'small'} color={'error'}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
